export const commandPaletteTranslations = {
  ar: {
    'Current page': 'الصفحة الحالية',
    'Focus page search': 'التركيز على بحث الصفحة',
    'Open page filters': 'فتح عوامل تصفية الصفحة',
    'Refresh current list': 'تحديث القائمة الحالية',
    'Recently used': 'استُخدم مؤخراً',
    'Recent commands could not be saved in this browser.': 'تعذّر حفظ الأوامر الأخيرة في هذا المتصفح.',

    'Commands': 'الأوامر',
    'Command palette': 'لوحة الأوامر',
    'Search commands': 'البحث في الأوامر',
    'Commands available': 'الأوامر المتاحة',
    'Use arrow keys to select, Enter to run, Escape to close.': 'استخدم الأسهم للتحديد وEnter للتنفيذ وEscape للإغلاق.',
    'No matching commands. Try another search.': 'لا توجد أوامر مطابقة. جرّب بحثاً آخر.',
    'No commands available in this workspace.': 'لا توجد أوامر متاحة في مساحة العمل هذه.',
    'Unable to run this command. Please try again.': 'تعذّر تنفيذ هذا الأمر. حاول مرة أخرى.',
  },
  tr: {
    'Current page': 'Geçerli sayfa',
    'Focus page search': 'Sayfa aramasına odaklan',
    'Open page filters': 'Sayfa filtrelerini aç',
    'Refresh current list': 'Geçerli listeyi yenile',
    'Recently used': 'Yakın zamanda kullanıldı',
    'Recent commands could not be saved in this browser.': 'Son komutlar bu tarayıcıda kaydedilemedi.',

    'Commands': 'Komutlar',
    'Command palette': 'Komut paleti',
    'Search commands': 'Komut ara',
    'Commands available': 'Kullanılabilir komutlar',
    'Use arrow keys to select, Enter to run, Escape to close.': 'Seçmek için ok tuşlarını, çalıştırmak için Enter, kapatmak için Escape kullanın.',
    'No matching commands. Try another search.': 'Eşleşen komut yok. Başka bir arama deneyin.',
    'No commands available in this workspace.': 'Bu çalışma alanında kullanılabilir komut yok.',
    'Unable to run this command. Please try again.': 'Bu komut çalıştırılamadı. Lütfen tekrar deneyin.',
  },
}
